import { Grid } from "@mui/material";
import React from "react";
import LazyPosHeader from "./home/header";
import LazyPosTable from "./home/table";

const LazyPos = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <LazyPosHeader />
      </Grid>
      <Grid item xs={12}>
        <LazyPosTable />
      </Grid>
    </Grid>
  );
};

export default LazyPos;
